$(document).ready(function () {
  $(".tpl__js-anchor-link").on("click", function (e) {
    e.preventDefault();
    var t = $(this).attr("href"),
      l = $(t).offset().top - 30;
    $(".tpl__js-open-menu-btn").hasClass("tpl__is-active") &&
      ($(".tpl__js-open-menu-btn").removeClass("tpl__is-active"),
      $("html").removeClass("tpl__is-fixed"),
      $(".tpl-menu").removeClass("tpl__is-opened")),
      $("html, body").animate({ scrollTop: l }, 400);
  }),
    $(".tpl__js-open-menu-btn").on("click", function (e) {
      e.preventDefault(),
        $(this).toggleClass("tpl__is-active"),
        $("html").toggleClass("tpl__is-fixed"),
        $(".tpl-menu").toggleClass("tpl__is-opened");
    }),
    $(".tpl__js-required-input").on("focus", function () {
      $(this).hasClass("tpl__is-error") && $(this).removeClass("tpl__is-error");
    }),
    $(".tpl-form [type=checkbox]").each(function () {
      $(this).on("change", function (e) {
        $(this).prop("checked")
          ? $(this)
              .parents(".tpl-form-checkbox__label")
              .find(".tpl-form-input__error")
              .css("display", "none")
          : $(this)
              .parents(".tpl-form-checkbox__label")
              .find(".tpl-form-input__error")
              .css("display", "block");
      });
    }),
    $(".tpl-marquee__init").marquee({
      delayBeforeStart: 0,
      duplicated: !0,
      startVisible: !0,
    });
}),
  document.addEventListener("DOMContentLoaded", function () {
    let e = document.querySelector(".tpl-popup"),
      t = e.querySelector(".tpl-popup__body"),
      l = e.querySelectorAll(".tpl__js-close-popup-btn"),
      s = e.querySelector(".tpl-form"),
      o = s.querySelector(".tpl-form-input"),
      n = s.querySelector(".tpl-form-input__error"),
      r = document.documentElement,
      i = document.querySelector(".tpl-popup"),
      p = document.querySelector(".tpl-popup__overflow"),
      a = "true" === localStorage.getItem("popupInteracted");
    function c() {
      (i.style.display = "none"),
        p.classList.remove("blur"),
        r.classList.remove("tpl__is-fixed"),
        localStorage.setItem("popupInteracted", "true");
    }
    a ||
      ((i.style.display = "block"),
      p.classList.add("blur"),
      r.classList.add("tpl__is-fixed")),
      (n.style.display = "none"),
      s.addEventListener("submit", function (e) {
        e.preventDefault(),
          o.value.trim()
            ? ((n.style.display = "none"), o.classList.remove("has-error"), c())
            : ((n.style.display = "block"), o.classList.add("has-error"));
      }),
      o.addEventListener("input", function () {
        o.value.trim() &&
          ((n.style.display = "none"), o.classList.remove("has-error"));
      }),
      l.forEach((e) => {
        e.addEventListener("click", function (e) {
          e.preventDefault(), c();
        });
      }),
      t.addEventListener("click", function (e) {
        e.stopPropagation();
      }),
      e.addEventListener("click", function (e) {
        e.stopPropagation();
      });
  }),
  document.addEventListener("DOMContentLoaded", function () {
    let e = 0,
      t = document.querySelectorAll(".tpl-offer__license");
    t.length > 0 &&
      (t.forEach(function (t) {
        e = Math.max(e, t.offsetHeight);
      }),
      t.forEach(function (t) {
        t.style.minHeight = e + "px";
      }));
  });
